// extracted by mini-css-extract-plugin
module.exports = {"paper":"MobileBottomDrawer_paper__3WQk2","close":"MobileBottomDrawer_close__17nF9","content":"MobileBottomDrawer_content__1OEli"};